function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}.cls-2{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "LinkedInIconDarkTheme");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Capa_1",
  "data-name": "Capa 1"
}, React.createElement("circle", {
  className: "cls-1",
  cx: 74.41,
  cy: 74.41,
  r: 71.41
}), React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1-2"
}, React.createElement("path", {
  id: "LinkedIn",
  className: "cls-2",
  d: "M104.5,80.72V103h-13V82.21c0-5.24-1.87-8.81-6.56-8.81a7.09,7.09,0,0,0-6.65,4.74,8.87,8.87,0,0,0-.43,3.16V103h-13s.17-35.32,0-39h13v5.52l-.09.13h.09v-.13A12.87,12.87,0,0,1,89.54,63.1C98.11,63.17,104.5,68.74,104.5,80.72ZM51.38,45.3c-4.43,0-7.33,2.91-7.33,6.73s2.82,6.74,7.16,6.74h.09c4.52,0,7.33-3,7.33-6.74S55.82,45.3,51.38,45.3ZM44.82,103h13V64h-13Z"
})))));

var SvgLinkedInIconDarkTheme = function SvgLinkedInIconDarkTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 148.82 148.82",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedInIconDarkTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LinkedInIconDarkTheme.cde84f3d.svg";
export { ForwardRef as ReactComponent };